import * as Actions from '../actions/actions';
import {sendRequest} from '../../../lib-alme-request/src/lib-alme-request';
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {Dictionary} from "../../../../types/rendering";
import LiveChatState from "../livechat-state";


const DELETE = 46;
const BACKSPACE = 8;


export default class InputBoxLiveChatMutator
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _stateManager: LiveChatState;
    _lastKeyId: NodeJS.Timeout | null = null;
    _eventValue = "";


    //#region Public Interface

    constructor(settings: DefaultSettings, stateManager: LiveChatState)
    {
        this._settings = settings;
        this._stateManager = stateManager;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;

        setInterval(() =>
        {
            const { Base, userTyping } = this._settings.stateLocations.LiveChat;
            let userTypingStatus = this._store?.getState()[Base][userTyping];

            if (userTypingStatus === "PAUSED")
            {
                userTypingStatus = "FINISHED";
            }
            else if (userTypingStatus === "STARTED" && this._stateManager.isOnline)
            {
                if(this._eventValue || this._settings.livechat.allowEmptyTypingEvent){
                    const input = {
                        messageType: this._settings.messageConstants.reportingEventRequest,
                        eventName: this._settings.livechat.reportingEventConstants.userTypingEventName,
                        eventValue: this._eventValue,
                    };
                    sendRequest(input);
                }

                userTypingStatus = "PAUSED";
            }

            this._store?.dispatch(Actions.setUserTypingState(`${Base}.${userTyping}`, userTypingStatus));

        }, this._settings.livechat.timeouts.typingStateTransitionInterval);
    }

    getReducer()
    {
        return (state = defaultState): AlmeState => state;
    }

    getMutator()
    {
        return (parameters: Dictionary): Dictionary =>
        {
            const newParams = { ...parameters };
            const handleKeyPress = (evt: KeyboardEvent): void =>
            {
                if (this._lastKeyId) { clearTimeout(this._lastKeyId); }

                this._eventValue = (evt.key === this._settings.textConstants.submitKey) ? '' : (evt.currentTarget as HTMLInputElement)?.value;
                const isEmpty = !(evt.currentTarget as HTMLInputElement)?.value;

                this._lastKeyId = setTimeout(() =>
                {
                    const { Base, userTyping } = this._settings.stateLocations.LiveChat;
                    const userTypingStatus = isEmpty ? "FINISHED" : "STARTED";

                    this._store?.dispatch(Actions.setUserTypingState(`${Base}.${userTyping}`, userTypingStatus));
                }, 50);
            };

            const handleKeyDown = (evt: KeyboardEvent): void =>
            {
               if ([BACKSPACE, DELETE].includes(evt.keyCode)) { handleKeyPress(evt); }
            };

            if (this._stateManager.isOnline)
            {
                if (!newParams.attributes) { newParams.attributes = {}; }
                const attributes = newParams.attributes as Dictionary;

                if (this._stateManager.isQueuedStatus(this._stateManager.sessionStatus))
                {
                    const { pendingPlaceholder } = this._settings.livechat.textConstants;
                    const accessKey = this._store?.getState()[this._settings.stateLocations.Conversation.Base][this._settings.stateLocations.Conversation.accessKey];
                    // both placeholder locations seem to be needed for multiple browser support
                    if (this._settings.EnableInputBoxForTheseAccessKeys.includes(accessKey)) {
                        const { inputboxPlaceholderText } = this._settings.textConstants;
                        newParams.maxLength = this._settings.livechat.maxInputLength;
                        attributes.placeholder = inputboxPlaceholderText;
                        attributes['aria-label'] = inputboxPlaceholderText;
                        newParams.placeholder = inputboxPlaceholderText;
                        newParams.onkeypress = handleKeyPress;
                        newParams.onkeydown = handleKeyDown;
                        newParams.disabled = false;
                    }
                    else {
                        attributes.placeholder = pendingPlaceholder;
                        attributes['aria-label'] = pendingPlaceholder;
                        newParams.placeholder = pendingPlaceholder;
                        newParams.disabled = true;
                    }
                }
                else {
                    const { inputboxPlaceholderText } = this._settings.textConstants;

                    newParams.maxLength = this._settings.livechat.maxInputLength;
                    attributes.placeholder = inputboxPlaceholderText;
                    attributes['aria-label'] = inputboxPlaceholderText;
                    newParams.placeholder = inputboxPlaceholderText;
                    newParams.onkeypress = handleKeyPress;
                    newParams.onkeydown = handleKeyDown;
                }
            }

            return newParams;
        };
    }

    //#endregion
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/renderers/inputbox-mutator.ts